import { ChancenkurveLevelConfig } from '../entities/ChancenkurveLevelConfig.js';
import { ChancenkurveSubjectConfig } from '../entities/ChancenkurveSubjectConfig.js';
import { ChancenkurveThresholdTransition } from '../entities/ChancenkurveThresholdTransition.js';

/**
 * Create default German subject configuration
 */
export function createDefaultGermanConfig(): ChancenkurveSubjectConfig {
  const config = new ChancenkurveSubjectConfig({
    _id: '_germanConfig',
    subject: 'german',
    entryLevel: 'N4',
    levels: [
      new ChancenkurveLevelConfig({
        _id: 'german_N2',
        levelId: 'N2',
        name: 'N2',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'N4',
          minAccuracyPercent: 80,
          minSpeed: 10,
        }),
      }),
      new ChancenkurveLevelConfig({
        _id: 'german_N4',
        levelId: 'N4',
        name: 'N4',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'N6',
          minAccuracyPercent: 80,
          minSpeed: 10,
        }),
        moveDown: new ChancenkurveThresholdTransition({
          targetLevel: 'N2',
          maxAccuracyPercent: 33,
          maxSpeed: 5,
        }),
      }),
      new ChancenkurveLevelConfig({
        _id: 'german_N6',
        levelId: 'N6',
        name: 'N6',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'COMPLETED',
          minAccuracyPercent: 80,
          minSpeed: 13,
        }),
        moveDown: new ChancenkurveThresholdTransition({
          targetLevel: 'N4',
          maxAccuracyPercent: 33,
          maxSpeed: 5,
        }),
      }),
    ],
  });
  return config;
}

/**
 * Create default Math Subtraction subject configuration
 */
export function createDefaultMathSubtractionConfig(): ChancenkurveSubjectConfig {
  const config = new ChancenkurveSubjectConfig({
    _id: '_mathSubtractionConfig',
    subject: 'math_subtraction',
    entryLevel: 'Station3',
    levels: [
      new ChancenkurveLevelConfig({
        _id: 'math_Station1',
        levelId: 'Station1',
        name: 'Station 1',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'Station2',
          minAccuracyPercent: 90,
          minSpeed: 14,
        }),
      }),
      new ChancenkurveLevelConfig({
        _id: 'math_Station2',
        levelId: 'Station2',
        name: 'Station 2',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'Station3',
          minAccuracyPercent: 85,
          minSpeed: 12,
        }),
        moveDown: new ChancenkurveThresholdTransition({
          targetLevel: 'Station1',
          maxAccuracyPercent: 50,
          maxSpeed: 6,
        }),
      }),
      new ChancenkurveLevelConfig({
        _id: 'math_Station3',
        levelId: 'Station3',
        name: 'Station 3',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'Station4',
          minAccuracyPercent: 85,
          minSpeed: 12,
        }),
        moveDown: new ChancenkurveThresholdTransition({
          targetLevel: 'Station2',
          maxAccuracyPercent: 25,
          maxSpeed: 4,
        }),
      }),
      new ChancenkurveLevelConfig({
        _id: 'math_Station4',
        levelId: 'Station4',
        name: 'Station 4',
        lessonId: '',
        moveUp: new ChancenkurveThresholdTransition({
          targetLevel: 'COMPLETED',
          minAccuracyPercent: 85,
          minSpeed: 12,
        }),
        moveDown: new ChancenkurveThresholdTransition({
          targetLevel: 'Station3',
          maxAccuracyPercent: 33,
          maxSpeed: 6,
        }),
        moveDownFar: new ChancenkurveThresholdTransition({
          targetLevel: 'Station2',
          maxAccuracyPercent: 20,
          maxSpeed: 4,
        }),
      }),
    ],
  });
  return config;
}
